// @ts-check
import React from 'react';
import { useIntl, defineMessages, FormattedMessage } from 'react-intl';
import { Formik, Form, FormikHelpers } from 'formik';

import TextField from '~/components/Form/TextField';
import Button from '~/components/Button';

interface ValuesProps {
  currentPassword?: string,
  newPassword?: string,
  confirmPassword?: string,
}

interface ChangePasswordProps {
  onSubmit: (values: ValuesProps,
  formikHelpers: FormikHelpers<{
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
  }>) => void | Promise<void>,
  confirmCurrent?: boolean,
}


const ChangePasswordForm: React.FC<ChangePasswordProps> = ({ onSubmit, confirmCurrent = true }) => {
  const intl = useIntl();

  const errorMessages = defineMessages({
    required: {
      id: 'Form_Required',
      defaultMessage: 'Required',
    },
    noMatch: {
      id: 'Form_PasswordDoesntMatch',
      defaultMessage: "Passwords don't match.",
    },
  });

  return (
    <Formik
      validateOnBlur={false}
      validateOnChange={false}
      validate={(values) => {
        const errors:ValuesProps = {};

        if (confirmCurrent && !values.currentPassword) errors.currentPassword = intl.formatMessage(errorMessages.required);
        if (!values.newPassword) errors.newPassword = intl.formatMessage(errorMessages.required);
        if (!values.confirmPassword) errors.confirmPassword = intl.formatMessage(errorMessages.required);

        if (values.confirmPassword !== values.newPassword) errors.newPassword = intl.formatMessage(errorMessages.noMatch);

        return errors;
      }}
      onSubmit={onSubmit}
      initialValues={{
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      }}
    >
      {({ errors, isSubmitting }) => (
        <Form>
          <h3><FormattedMessage id="ChangePassword__Heading" defaultMessage="Change password" /></h3>

          {
            confirmCurrent && (
              <TextField name="currentPassword" type="password" error={errors.currentPassword}>
                <FormattedMessage id="ChangePassword__Current" defaultMessage="Current password" />
              </TextField>
            )
          }

          <TextField name="newPassword" type="password" error={errors.newPassword}>
            <FormattedMessage id="ChangePassword__New" defaultMessage="New password" />
          </TextField>

          <TextField name="confirmPassword" type="password" error={errors.confirmPassword}>
            <FormattedMessage id="ChangePassword__Confirm" defaultMessage="Confirm password" />
          </TextField>

          <Button disabled={isSubmitting} type="submit">
            {isSubmitting ? 'Saving...' : 'Change password'}
          </Button>
        </Form>
      )}
    </Formik>
  );
};

export default ChangePasswordForm;
